var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PayResultCheck',{attrs:{"visible":_vm.PayResultCheckVisible},on:{"update:visible":function($event){_vm.PayResultCheckVisible=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }